import { stardust } from '@eidellev/adonis-stardust/client';
import { scrollIntoView } from 'seamless-scroll-polyfill';

import Pristine from '../modules/pristine';
import { getPageLang } from '../modules/utils';

document.addEventListener('DOMContentLoaded', function() {
  const floatingLabels = document.querySelectorAll('.rlx-form__label');

  floatingLabels.forEach(function(label) {
    const input = label.nextElementSibling as HTMLInputElement | HTMLSelectElement;

    // on load check if its filled out
    if (input.value !== '') {
      label.classList.add('rlx-form__label--active');
    }

    input.addEventListener('focus', function() {
      label.classList.add('rlx-form__label--active');
    });

    input.addEventListener('blur', function() {
      if (!input.value?.length) {
        label.classList.remove('rlx-form__label--active');
      }
    });

    input.addEventListener('change', function() {
      if (!input.value?.length) {
        label.classList.remove('rlx-form__label--active');
      } else {
        label.classList.add('rlx-form__label--active');
      }
    });

    input.addEventListener('reset', function() {
      label.classList.remove('rlx-form__label--active');
    });
  });
});

document.addEventListener('DOMContentLoaded', async () => {
  const form = document.querySelector('.js-rlx-contact-form') as HTMLFormElement;

  if (!form) {
    return;
  }

  const pristine = new Pristine(form, {
    classTo: 'rlx-form__field',
    errorTextParent: 'rlx-form__field',
  }, true);

  const steps = form.querySelectorAll<HTMLElement>('.rlx-form__step');

  const backBtn = form.querySelector('.js-form-back');
  const nextBtn = form.querySelector('.js-form-next');
  const resetBtn = form.querySelector('.js-form-reset');

  function navigateTo(index: number) {
    steps.forEach((step, i) => {
      let inputs = step.querySelectorAll<HTMLInputElement>('input,button,select,textarea');

      if (i === index) {
        step.classList.add('rlx-form__step--active');
        step.removeAttribute('aria-hidden');

        inputs.forEach((input) => {
          input.removeAttribute('tabindex');
        });
      } else {
        step.classList.remove('rlx-form__step--active');
        step.setAttribute('aria-hidden', 'true');

        inputs.forEach((input) => {
          input.setAttribute('tabindex', '-1');
        });
      }
    });

    steps[index].dispatchEvent(new CustomEvent('changed', { bubbles: true, detail: { step: index } }));
  }

  function currentIndex() {
    return Array.from(steps).findIndex((step) => !step.hasAttribute('aria-hidden'));
  }

  function checkValid(step: HTMLElement) {
    const inputs = step.querySelectorAll<HTMLInputElement>('input,button,select,textarea');
    return pristine.validate(inputs, false);
  }

  backBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    navigateTo(currentIndex() - 1);
  });

  // Next button goes forward if current block validates
  nextBtn?.addEventListener('click', (e) => {
    e.preventDefault();

    const index = currentIndex();

    const valid = checkValid(steps[index]);

    if (!valid) {
      return;
    }

    navigateTo(index + 1);
    scrollIntoView(form, { behavior: 'smooth' });
  });

  resetBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    navigateTo(0);
    form.reset();
    pristine.reset();
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const valid = pristine.validate();

    const honeypot = form.querySelector<HTMLInputElement>('[name="birthday"]')?.value;

    const submitBtn = form.querySelector('[type=submit]') as HTMLInputElement;

    const successMsg = form.querySelector('.js-rlx-success');
    const errorMsg = form.querySelector('.js-rlx-error');

    successMsg?.setAttribute('aria-hidden', 'true');
    errorMsg?.setAttribute('aria-hidden', 'true');

    if (valid && !honeypot) {
      submitBtn!.disabled = true;
      submitBtn.classList.add('submitting');

      const formData = new FormData(form);

      // Add language to form submission
      const lang = getPageLang();
      formData.append('lang', lang);

      try {
        const url = stardust.route('api.forms.rolex-sendgrid');
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: formData,
        });

        // const json = await response.json();

        if (response.ok) {
          // Rolex spec: contactForm fires only once the form has been submitted successfully
          try {
            window._satellite.track('contactForm');
          } catch {
            console.error('Adobe Analytics not loaded');
          }

          submitBtn.classList.remove('submitting');
          submitBtn.disabled = false;
          // form.reset();
          // pristine.reset();

          successMsg?.removeAttribute('aria-hidden');

          navigateTo(currentIndex() + 1);

          scrollIntoView(form, { behavior: 'smooth' });

          // smoothScroll(successMsg);
        } else {
          submitBtn.classList.remove('submitting');

          errorMsg?.removeAttribute('aria-hidden');

          navigateTo(currentIndex() + 1);

          scrollIntoView(form, { behavior: 'smooth' });

          // smoothScroll(errorMsg);
        }
      } catch (error) {
        console.error(error);
      }
    }
  });
});
